import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { parsePriceNumber } from "../utils/priceFormat";

/** Stripe catalog ids by ascending tier position. */
export const TIER_CATALOG_BY_INDEX = ["supporter", "inner", "vip"];

export function normalizeCreatorTiers(rawTiers = []) {
  return [...(rawTiers || [])]
    .filter(Boolean)
    .map((t, i) => ({
      ...t,
      key: t.id || t.tierId || t.key || `tier-${i}`,
      name: t.name || t.tierName || `Tier ${i + 1}`,
      price: t.price ?? t.priceLabel ?? "",
      perks: Array.isArray(t.perks)
        ? t.perks.map((p) => (typeof p === "string" ? p : p?.label || p?.name || "")).filter(Boolean)
        : [],
      description: t.description || t.summary || t.tagline || "",
    }))
    .sort((a, b) => parsePriceNumber(a.price) - parsePriceNumber(b.price))
    .slice(0, 3)
    .map((t, i) => ({
      ...t,
      catalogId: TIER_CATALOG_BY_INDEX[i] || "supporter",
      accentIndex: i,
    }));
}

/**
 * Prefer users/{creatorId}.tiers; fall back to supportTiers collection.
 * Always sorted ascending by price, max 3.
 */
export async function getCreatorTiers(creatorId) {
  if (!creatorId) return [];

  try {
    const userSnap = await getDoc(doc(db, "users", creatorId));
    if (userSnap.exists()) {
      const fromUser = normalizeCreatorTiers(userSnap.data()?.tiers);
      if (fromUser.length) return fromUser;
    }
  } catch (err) {
    console.warn("getCreatorTiers user doc:", err);
  }

  const tiersQuery = query(
    collection(db, "supportTiers"),
    where("creatorId", "==", creatorId)
  );
  const snapshot = await getDocs(tiersQuery);
  return normalizeCreatorTiers(
    snapshot.docs.map((tierDoc) => ({ id: tierDoc.id, ...tierDoc.data() }))
  );
}

export function catalogIdForTierIndex(index) {
  return TIER_CATALOG_BY_INDEX[index] || "supporter";
}
